<template>
  <div
    v-if="cookiesBannerStatus"
    class="fixed z-10 flex flex-row items-center justify-center w-full p-2 text-center bg-gray"
    data-cy="cookie-banner"
    @click="hideCookiesBanner"
  >
    <p>
      En poursuivant votre navigation, vous acceptez l’utilisation de cookies pour vous proposer des services et des offres adaptés à vos centres d’intérêts et pour réaliser des statistiques de visites. Pour en savoir plus et refuser les cookies <a class="click-here" @click="showModal()">cliquez ici</a>
      <a data-cy="close-cookie-banner" @click="hideCookiesBanner" class="time-cross">&times;</a>
    </p>
  </div>
</template>

<script>
import CookiesModalContent from '@/components/CookiesModalContent'
export default {
  name: 'CookieBanner',
  data () {
    return {
      cookiesBannerStatus: true
    }
  },
  methods: {
    showModal () {
      this.$modal.show(
        CookiesModalContent,
        {},
        { width: '80%', height: 'auto', scrollable: true, name: 'total-cookie-modal' },
      )
    },
    hideCookiesBanner () {
      this.$cookie.set(`total-quizelearningCNIL`, true)
      this.cookiesBannerStatus = false
    },
  },

  mounted () {
    this.cookiesBannerStatus = !this.$cookie.get(`total-quizelearningCNIL`)
  }
}
</script>

<style lang="scss" scoped>
.click-here {
  text-decoration: underline;
  cursor: pointer;
}
.time-cross {
  cursor: pointer;
  font-weight: bold;
  margin-left: 10px;
}
</style>
